import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import { onlyUniqueNonBlank } from '../../../lib/helpers/ArrayHelper';

export const GetSkus = (item: SmartSendItemApiModel): string[] =>
  item.MarketplaceOrderLines.map((x) => x.Product?.Sku).filter(onlyUniqueNonBlank);
